import React, { useContext, useState } from 'react';
import { Form, Button, } from 'react-bootstrap';
import { login } from '../Services/authService';
import { AuthContext } from '../contexts/AuthContext';
import AuthLayout from '../Components/Layouts/AuthLayout';
import { Breadcrumbs } from "../Components/Breadcrumbs";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const LoginScreen = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const auth = useContext(AuthContext);


    const loginHandler = async (e) => {
        e.preventDefault();
        await login(auth.login, email, password);
    };

    return auth.isAdmin() ? <Navigate to="/admin" /> : (
        <>
            <Helmet>
                <title>Login</title>
                <meta name="description" content=" This is the login Oasis Educational Institute" />
            </Helmet>

            <Breadcrumbs page="Login" path='/' label="Home" />
            <AuthLayout>
                <form onSubmit={loginHandler} className="p-4 max-w-xs mx-auto bg-white opacity-90 shadow-lg rounded-lg">
                    {/* Email Field */}
                    <div className="mb-4">
                        <label htmlFor="email" className="block font-medium text-sm text-gray-700 mb-1">
                            Email address
                        </label>
                        <input
                            type="email"
                            id="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <p className="text-red-500 text-xs mt-1">Please enter a valid email.</p>
                    </div>

                    {/* Password Field */}
                    <div className="mb-4">
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <p className="text-red-500 text-xs mt-1">Password is required.</p>
                    </div>

                    {/* Remember Me Checkbox */}
                    <div className="mb-6">
                        <label className="flex items-center">
                            <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-blue-600 rounded focus:ring-blue-500 border-gray-300"
                            />
                            <span className="ml-2 text-sm text-gray-700">Remember me</span>
                        </label>
                    </div>

                    {/* Login Button */}
                    <div>
                        <button
                            type="submit"
                            className="w-full bg-blue-600 text-white py-2 px-4 text-sm rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            Login
                        </button>
                    </div>
                </form>
            </AuthLayout>
        </>
    );
};

export default LoginScreen